import { lazy, Suspense } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from '@ah/ui';
import { DiProvider } from './providers/DiProvider';
import { AppI18nProvider } from './providers/AppI18nProvider';
import { RequireAuth } from './RequireAuth';
import DashboardPage from '../pages/DashboardPage';

const LoginPage = lazy(() => import('../features/auth/LoginPage'));
const TherapistsPage = lazy(() => import('../pages/TherapistsPage'));
const ContentPage = lazy(() => import('../pages/ContentPage'));
const LandingContentPage = lazy(() => import('../pages/LandingContentPage'));
const SpecializationsPage = lazy(() => import('../pages/SpecializationsPage'));
const MediaPage = lazy(() => import('../pages/MediaPage'));
const UsersPage = lazy(() => import('../pages/UsersPage'));
const ReviewsPage = lazy(() => import('../pages/ReviewsPage'));
const PaymentsPage = lazy(() => import('../pages/PaymentsPage'));
const PaymentsSettingsPage = lazy(() => import('../pages/PaymentsSettingsPage'));
const ReportsPage = lazy(() => import('../pages/ReportsPage'));
const SecurityPage = lazy(() => import('../pages/SecurityPage'));

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 2, refetchOnWindowFocus: false } },
});

function Loading() {
  return (
    <div role="status" style={{ padding: 24, textAlign: 'center' }}>
      Loading…
    </div>
  );
}

export function App() {
  return (
    <DiProvider>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <AppI18nProvider>
            <BrowserRouter>
              <Suspense fallback={<Loading />}>
                <Routes>
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/" element={<RequireAuth><DashboardPage /></RequireAuth>} />
                  <Route path="/therapists" element={<RequireAuth><TherapistsPage /></RequireAuth>} />
                  <Route path="/content" element={<RequireAuth><ContentPage /></RequireAuth>} />
                  <Route path="/landing" element={<RequireAuth><LandingContentPage /></RequireAuth>} />
                  <Route path="/specializations" element={<RequireAuth><SpecializationsPage /></RequireAuth>} />
                  <Route path="/media" element={<RequireAuth><MediaPage /></RequireAuth>} />
                  <Route path="/users" element={<RequireAuth><UsersPage /></RequireAuth>} />
                  <Route path="/reviews" element={<RequireAuth><ReviewsPage /></RequireAuth>} />
                  <Route path="/payments" element={<RequireAuth><PaymentsPage /></RequireAuth>} />
                  <Route path="/settings/payments" element={<RequireAuth><PaymentsSettingsPage /></RequireAuth>} />
                  <Route path="/settings/security" element={<RequireAuth><SecurityPage /></RequireAuth>} />
                  <Route path="/reports" element={<RequireAuth><ReportsPage /></RequireAuth>} />
                </Routes>
              </Suspense>
            </BrowserRouter>
          </AppI18nProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </DiProvider>
  );
}
